var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooksIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12486",
    "data-name": "Group 12486",
    transform: "translate(-0.467 -0.336)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1004",
    "data-name": "Rectangle 1004",
    width: 100,
    height: 100,
    transform: "translate(0.467 0.336)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11821",
    "data-name": "Group 11821",
    transform: "translate(12.783 5.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M621.443,167.179h-55.4a10.993,10.993,0,0,1,0-21.986h55.4a1.306,1.306,0,0,1,0,2.611h-55.4a8.382,8.382,0,0,0,0,16.763h55.4a1.306,1.306,0,0,1,0,2.611Z",
    transform: "translate(-555.13 -102.978)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M596.55,167.179a1.309,1.309,0,0,1-1.19-.764,24.638,24.638,0,0,1,0-20.459,1.306,1.306,0,0,1,2.377,1.084,22.02,22.02,0,0,0,0,18.289,1.306,1.306,0,0,1-.646,1.73A1.272,1.272,0,0,1,596.55,167.179Z",
    transform: "translate(-532.54 -102.978)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M575.051,159.465h-4.928a1.306,1.306,0,0,1-1.306-1.307v-6.8a1.305,1.305,0,0,1,1.306-1.306h4.928a1.307,1.307,0,0,1,1.306,1.306v6.8A1.307,1.307,0,0,1,575.051,159.465Zm-3.623-2.613h2.317v-4.186h-2.317Z",
    transform: "translate(-546.977 -100.022)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M590.314,152.666H563.887a1.306,1.306,0,0,1,0-2.611h26.428a1.306,1.306,0,1,1,0,2.611Z",
    transform: "translate(-550.734 -99.992)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M610.283,171.9h-23.2a1.306,1.306,0,1,1,0-2.611h23.2a1.306,1.306,0,0,1,0,2.611Z",
    transform: "translate(-537.011 -88.551)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M593.267,179.226H570.373a10.993,10.993,0,0,1,0-21.984h55.4a1.306,1.306,0,0,1,0,2.611h-55.4a8.381,8.381,0,0,0,0,16.762h22.894a1.306,1.306,0,0,1,0,2.611Z",
    transform: "translate(-552.495 -95.876)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M600.884,179.227a1.306,1.306,0,0,1-1.19-.764,24.634,24.634,0,0,1,0-20.457,1.306,1.306,0,0,1,2.377,1.082,22.035,22.035,0,0,0,0,18.291,1.305,1.305,0,0,1-1.187,1.848Z",
    transform: "translate(-529.905 -95.877)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M602.52,164.714H576.095a1.306,1.306,0,0,1,0-2.611H602.52a1.306,1.306,0,1,1,0,2.611Z",
    transform: "translate(-543.533 -92.801)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M581.357,182.05a1.306,1.306,0,0,1-1.306-1.306V163.409a1.305,1.305,0,0,1,1.306-1.306h9.216a1.307,1.307,0,0,1,1.307,1.306v17.3a1.307,1.307,0,0,1-2.23.923l-3.664-3.665-3.7,3.7A1.307,1.307,0,0,1,581.357,182.05Zm1.306-17.336v12.877l2.4-2.4a1.345,1.345,0,0,1,1.846,0l2.359,2.359V164.714Z",
    transform: "translate(-540.306 -92.921)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M577.524,158.192a12.028,12.028,0,0,1-7.659-2.931c-3.837-3.208-5.951-8.357-5.951-14.5,0-4.107,1.217-7.291,3.617-9.463,3.538-3.2,8.728-3.43,12.46-3.055a27.7,27.7,0,0,0,5.268.019c3.74-.344,8.939-.072,12.464,3.145,2.372,2.164,3.573,5.311,3.573,9.354,0,6.141-2.114,11.29-5.951,14.5a11.642,11.642,0,0,1-9.458,2.772,18.513,18.513,0,0,0-6.562,0A10.213,10.213,0,0,1,577.524,158.192Zm-.076-27.464c-2.616,0-5.921.478-8.165,2.508-1.83,1.656-2.758,4.189-2.758,7.527,0,5.353,1.782,9.791,5.015,12.5a9.042,9.042,0,0,0,7.321,2.2,21.134,21.134,0,0,1,7.485,0,9.033,9.033,0,0,0,7.321-2.2c3.234-2.7,5.014-7.143,5.015-12.5,0-3.277-.917-5.776-2.722-7.426-2.97-2.711-7.832-2.714-10.465-2.473a30.144,30.144,0,0,1-5.765-.021C579.084,130.779,578.3,130.728,577.448,130.728Z",
    transform: "translate(-549.983 -113.138)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M587.913,141.293a1.307,1.307,0,0,1-1.306-1.306,6.647,6.647,0,0,0-1.864-5.138c-2.06-1.88-5.483-1.877-7.339-1.708a1.306,1.306,0,0,1-.238-2.6c2.791-.256,6.678-.048,9.338,2.38a9.116,9.116,0,0,1,2.714,7.067A1.306,1.306,0,0,1,587.913,141.293Z",
    transform: "translate(-542.734 -111.703)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M578.222,135.072a1.305,1.305,0,0,1-1.278-1.045,23.844,23.844,0,0,0-5.456-10.426,1.307,1.307,0,0,1,1.876-1.819,26.115,26.115,0,0,1,6.138,11.725,1.3,1.3,0,0,1-1.02,1.537A1.206,1.206,0,0,1,578.222,135.072Z",
    transform: "translate(-545.608 -117.074)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M578.042,130.748a23.974,23.974,0,0,1-3.549-.278,1.307,1.307,0,0,1-1.111-1.388c.01-.114,1.018-11.423,16.209-10.3a1.3,1.3,0,0,1,1.208,1.384,11.9,11.9,0,0,1-4.174,7.89A13.252,13.252,0,0,1,578.042,130.748Zm-1.812-2.7c3.711.339,6.643-.331,8.727-2a9.072,9.072,0,0,0,2.983-4.728C579.313,121.148,576.889,125.776,576.23,128.051Z",
    transform: "translate(-544.298 -118.704)",
    fill: "#2eafbe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksIcon);
export default __webpack_public_path__ + "static/media/books-icon.fbdcab8c70540a95a7a213bef41adef3.svg";
export { ForwardRef as ReactComponent };